export default "__VITE_ASSET__d0Hpqo6CHbR4aLffD8v8Hg__"